<template>
  <div>
    <el-row :gutter="5">
      <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
        <el-form-item label="CPF" prop="federalid">
          <el-input
            v-model="ruleForm.federalid.id"
            v-mask="'###.###.###-##'"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
        <el-form-item label="RG" prop="rg" v-mask="'##-##.###.###'">
          <el-input v-model="ruleForm.rg.id"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
        <el-form-item label="CNH" prop="cnh">
          <el-input
            v-model="ruleForm.cnh.id"
            v-mask="'#########-##'"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
        <el-form-item label="Foto">
          <el-upload
            class="avatar-uploader"
            action="federalid"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="changeFederal"
          >
            <img
              style="height: 450px; width: 400px"
              v-if="ruleForm.federalid.image"
              :src="ruleForm.federalid.image"
              class="image-service"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-col>
      <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
        <el-form-item label="Foto">
          <el-upload
            class="avatar-uploader"
            action="rg"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="changeRg"
          >
            <img
              style="height: 450px; width: 400px"
              v-if="ruleForm.rg.image"
              :src="ruleForm.rg.image"
              class="image-service"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-col>
      <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
        <el-form-item label="Foto" prop="imei">
          <el-upload
            class="avatar-uploader"
            action="cnh"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="changeCnh"
          >
            <img
              style="height: 450px; width: 400px"
              v-if="ruleForm.cnh.image"
              :src="ruleForm.cnh.image"
              class="image-service"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ServicesService } from "@/services/customers/services.services";
export default {
  name: "DriverDocument",
  data() {
    return {
      action: "",
      ruleForm: {
        federalid: {
          id: "",
          token: "",
          image: "",
        },
        rg: {
          id: "",
          token: "",
          image: "",
        },
        cnh: {
          id: "",
          token: "",
          image: "",
        },
      },
    };
  },
  computed: {
    getForm() {
      return this.ruleForm;
    },
  },
  methods: {
    set(response) {
      this.ruleForm.federalid.id = response.federalid;
      this.ruleForm.federalid.image = response.federalidImage;
      this.ruleForm.rg.id = response.rg;
      this.ruleForm.rg.image = response.rgImage;
      this.ruleForm.cnh.id = response.cnh;
      this.ruleForm.cnh.image = response.cnhImage;
    },

    upload(file, fileList, type) {
      var vm = this;
      ServicesService.upload(file)
        .then((response) => {
          vm.ruleForm[type].token = response.token;
          vm.ruleForm[type].image = response.content;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        });
    },
    changeFederal(file, fileList) {
      this.upload(file, fileList, "federalid");
    },
    changeRg(file, fileList) {
      this.upload(file, fileList, "rg");
    },
    changeCnh(file, fileList) {
      this.upload(file, fileList, "cnh");
    },
  },
};
</script>
